"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = void 0;
class Entity {
    constructor(schema, attributes, attributesContainerSchema, attributesContainerSchemaLocation) {
        this.schema = schema;
        this.attributes = attributes;
        this.attributesContainerSchema = attributesContainerSchema;
        this.attributesContainerSchemaLocation = attributesContainerSchemaLocation;
    }
    attributeNamed(attributeName) {
        for (const attribute of this.attributes) {
            if (attribute.name === attributeName) {
                return attribute;
            }
        }
        return undefined;
    }
}
exports.Entity = Entity;
